<template>
    <div class="nav-header flex-none transition items-center w-full">
          <div v-show="popoutHidden" class="flex w-full">
            <div class="flex-1">
              <button v-on:click="popoutHidden = !popoutHidden"
                class="flex items-center md:flex-col md:items-left nav-icon nav-icon-menu align-middle cursor-pointer relative border-0 bg-transparent hover:bg-transparent w-full focus:bg-gray-900 focus:outline-none rounded-none pl-2 md:p-0"
                aria-label="Account"
                aria-expanded="false"
              >
                <img v-if="avatar" :src="avatar" class="max-h-48 inline-block m-0 object-contain">
                <i v-else class="material-icons pr-0 hidden md:block">{{icon}}</i>
                <i aria-hidden="true" class="material-icons pr-2 md:pr-0 block md:hidden">menu</i>
                  <span>{{name}}</span>
                <i aria-hidden="true" class="material-icons pr-0 absolute right-0 arrow hidden md:block">keyboard_arrow_right</i>
              </button>
            </div>
          </div>

          <div v-if="! popoutHidden" class="visible-popout">
            <div class="flex-1">
              <button v-on:click="popoutHidden = true"
                class="flex items-center md:flex-col md:items-left nav-icon nav-icon-menu align-middle cursor-pointer relative border-0 bg-transparent hover:bg-transparent w-full focus:bg-gray-900 focus:outline-none rounded-none pl-2 md:p-0"
                aria-label="Account"
                aria-expanded="true"
              >
                  <img v-if="avatar" :src="avatar" class="max-h-48 inline-block m-0 object-contain">
                  <i v-else class="material-icons pr-0 hidden md:block">{{icon}}</i>
                  <i aria-hidden="true" class="material-icons pr-2 md:pr-0 block md:hidden">menu</i>
                    <span>{{name}}</span>
                  <i aria-hidden="true" class="material-icons pr-0 absolute arrow hidden md:block">keyboard_arrow_left</i>
              </button>
            </div>

            <div class="full-popout top-0" v-click-outside="onClickOutside">
              <slot></slot>
            </div>
          </div>
      </div>
</template>

<script>
import vClickOutside from 'v-click-outside'

  export default {

      props: {
        name: '',
        icon: '',
        avatar: '',
      },

        data() {
          return {
            popoutHidden: true,
            success: false,
            loaded: true,
          }
        },

        directives: {
          clickOutside: vClickOutside.directive
        },
        methods: {
          onClickOutside (event) {
              this.popoutHidden = !this.popoutHidden
              // console.log('Clicked outside. Event: ', event)
          }
        }

      };
</script>
